<div class="content-container">
    <div>
        <h1 mat-dialog-title>{{data.message}}</h1>
    </div>
<button class="btn btn-cancel" style="margin-right:10px; background-color: rgb(247, 72, 72);color: #fff; text-align: center;" id="no-button" [mat-dialog-close]="false">NO</button>
<button class="btn btn-cancel" style="margin-right:10px; background-color: rgb(247, 72, 72);color: #fff; text-align: center;" id="yes-button" [mat-dialog-close]="true">YES</button>
</div>